/* styled.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["truncateInline", "withoutBackground", "isHovered", "isInteractive", "isSelected", "href", "viewType"],
  _excluded2 = ["truncateInline", "withoutBackground", "isHovered", "isInteractive", "isSelected", "href", "viewType"];
import "./styled.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef } from 'react';
import { B100, B200, B400, B50, N40 } from '@atlaskit/theme/colors';
import { expVal } from '@atlaskit/tmp-editor-statsig/expVal';
export var WrapperSpan = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var truncateInline = _ref.truncateInline,
    withoutBackground = _ref.withoutBackground,
    isHovered = _ref.isHovered,
    isInteractive = _ref.isInteractive,
    isSelected = _ref.isSelected,
    href = _ref.href,
    viewType = _ref.viewType,
    props = _objectWithoutProperties(_ref, _excluded);
  var experimentValue = viewType === 'unauthorised' ? expVal('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
  return /*#__PURE__*/React.createElement("span", _extends({
    ref: ref
  }, props, {
    className: ax(["_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28", truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf", truncateInline && experimentValue !== 'control' && "_syaz15cr", withoutBackground ? "_19bvidpf _18u01i6y" : "_19it1x13 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1", isHovered && "_1h6dmr28", isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1", isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw71x13 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv"])
  }), props.children);
});
export var WrapperAnchor = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var truncateInline = _ref2.truncateInline,
    withoutBackground = _ref2.withoutBackground,
    isHovered = _ref2.isHovered,
    isInteractive = _ref2.isInteractive,
    isSelected = _ref2.isSelected,
    href = _ref2.href,
    viewType = _ref2.viewType,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var experimentValue = viewType === 'unauthorised' ? expVal('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
  return /*#__PURE__*/React.createElement("a", _extends({
    href: href,
    ref: ref
  }, props, {
    className: ax(["_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28", truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf", truncateInline && experimentValue !== 'control' && "_syaz15cr", withoutBackground ? "_19bvidpf _18u01i6y" : "_19it1x13 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1", isHovered && "_1h6dmr28", isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1", isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw71x13 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv", isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"])
  }), props.children);
});
var baseWrapperStyles = null;

// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
var interactiveStyles = null;
var hoveredStyles = null;
var hoveredWithBackgroundStyles = null;
var withoutBackgroundStyles = null;
var withBackgroundStyles = null;
var truncateStyles = null;
var unauthorisedTruncateStyles = null;
var notSelectedStyle = null;
var selectedStyles = null;